import { useEffect } from 'react';
import baseURL from '../url';
import { safeGet, safeSet, getSafeSession, safeJsonParse } from '../utils/browserSafe';

export default function AbandonedCartTracker(){
  useEffect(()=>{
    let last='';
    const send=()=>{
      try{
        const cart=safeGet('cart','[]');
        if(cart===last || cart==='[]') return;
        last=cart;
        const data=new FormData();
        data.append('carritoJson',cart);
        data.append('sessionKey', getSafeSession());
        (typeof navigator !== 'undefined' && navigator.sendBeacon) ? navigator.sendBeacon(`${baseURL}/abandonedCartSave.php`, data) : fetch(`${baseURL}/abandonedCartSave.php`,{method:'POST',body:data});
      }catch(e){}
    };
    send();
    window.addEventListener('cartUpdated', send);
    const id=setInterval(send,30000);
    return()=>{window.removeEventListener('cartUpdated',send);clearInterval(id);};
  },[]);
  return null;
}
